// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

type MinusStrokeProps = {
  title?: string;
  className?: string;
};

export function MinusStroke({
  title = 'MinusStroke',
  className,
}: MinusStrokeProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      aria-label={title}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM6 11V13L18 13V11H6Z"
        fill="currentColor"
      />
    </svg>
  );
}
